export default {"src":"/_next/static/image/public/assets/icons/chevron-left.eaa51929d36c7159c2b6d61eb190144f.svg","height":20,"width":20};